import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate } from "react-router-dom";

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
    color: "#e7e7e9",
    padding: "32px 16px 48px",
    fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
    borderRadius: "18px",
    padding: "18px 16px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "8px",
  },
  titleWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  badge: {
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    padding: "6px 12px",
    borderRadius: "999px",
    fontWeight: 800,
    fontSize: "12px",
    display: "inline-block",
    border: "1px solid rgba(255,255,255,0.12)",
  },
  title: {
    margin: 0,
    fontSize: "24px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "-0.02em",
  },
  helper: {
    margin: 0,
    color: "#cbd5e1",
    fontSize: "13px",
    lineHeight: 1.5,
  },
  trackButton: {
    marginTop: "8px",
    alignSelf: "center",
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#ffffffff",
    border: "none",
    borderRadius: "10px",
    padding: "10px 14px",
    fontWeight: 700,
    fontSize: "13px",
    cursor: "pointer",
    boxShadow: "0 10px 24px rgb(87, 87, 87)",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
  },
};

export default function SetPage() {
  const [cookies] = useCookies(['uuid']);

  // 쿠키에서 UUID를 이용하여 사용자 정보 가져오기
  const[uid,setUID] = useState(0);
  const[super_user,setSuperuser] = useState('');
  
  const location = useLocation();
  const navigate = useNavigate();

  // const[margin,setMargin] = useState('');
  const [trackStartChecks, setTrackStartChecks] = useState({});

  // ✅ 권한 확인
  const fetchUserInfo = (uuid) => {
    fetch(`/SetPage/admin_user?uuid=${uuid}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("서버 응답 실패");
        }
        return response.json();
      })
      .then((data) => {
        const user = data[0];
        if (user && (user.super_user === 1 || user.super_user === "1")) {
          setUID(user.uid);
          setSuperuser(user.super_user);
        } else {
          alert("접근 권한이 없습니다.");
          navigate("/SelectPage", { replace: true });
        }
      })
      .catch((error) => {
        console.error("fetchUserInfo 오류:", error);
        alert("로그인 정보가 존재하지 않습니다. 로그인 페이지로 이동합니다.");
        navigate("/LoginAts", { replace: true });
      });
  };

  useEffect(() => {
    if (!uid) return; // uid가 없으면 실행하지 않음
  
    const WS_URL =
      window.location.hostname === "127.0.0.1"
        ? "ws://127.0.0.1:8000/ws_set_track"
        : "wss://speedbotpro.com/ws_set_track";
  
    let ws;
    let reconnectTimer;
    let isUnmounted = false;
  
    const connectWebSocket = () => {
      ws = new WebSocket(WS_URL);
  
      ws.onopen = () => {
        console.log("✅ 웹소켓 연결 성공:", WS_URL);
        ws.send(JSON.stringify({ type: "init", uid, role: "admin", scope: "set_track" }));
      };
  
      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);

          if (data?.symbol) {
            setTrackStartChecks(prev => ({
              ...prev,
              [data.symbol]: data.start_check
            }));
          }
  
          // 필요한 정보는 trackStartChecks에만 반영
        } catch (err) {
          console.error("⚠️ JSON 파싱 오류:", err);
        }
      };
  
      ws.onerror = (error) => {
        console.error("❌ 웹소켓 에러:", error);
      };
  
      ws.onclose = (event) => {
        console.warn("🔌 웹소켓 연결 종료:", event.code);
        if (!isUnmounted && (event.code === 1006 || event.code === 426)) {
          console.log("🔁 5초 후 재연결 시도...");
          reconnectTimer = setTimeout(connectWebSocket, 5000);
        }
      };
    };
  
    connectWebSocket();
  
    // uid가 세팅되면 검색 함수 실행
    onClickSearch(symbol);
  
    return () => {
      isUnmounted = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      if (ws) ws.close();
    };
  }, [uid]);

  // ✅ uuid / 경로 변경될 때마다 권한 체크
  useEffect(() => {
    if (!cookies.uuid) {
      alert("로그인 정보가 존재하지 않습니다. 관리자 로그인 페이지로 이동합니다.");
      navigate("/LoginAts", { replace: true });
    } else {
      fetchUserInfo(cookies.uuid);
    }
  }, [cookies.uuid, location.pathname]);

  useEffect(() => {
    fetch('/set_setdata_track_day_extend')
      .then((res) => res.json())
      .then((data) => {
        setDayExtend(parseInt(data.day_extend, 10) === 1 ? 1 : 0);
      })
      .catch((err) => console.error('1일연장 조회 오류:', err));
  }, []);

  const[symbol,setSymbol] = useState('default');
  const[position_mode, setPositionMode] = useState('CROSS');
  const[leverage_info, setLeverage] = useState(20);

  const[entry_time,setEntryTime] = useState('9:00');
  const[entry_usdt_per,setEntryUsdtPer] = useState(0.5);
  const[martin1_reserve_gap, setMartin1ReserveGap] = useState(2.0);
  const[martin1_amount_per, setMartin1AmountPer] = useState(1.0);
  const[martin2_reserve_gap, setMartin2ReserveGap] = useState(4.0);
  const[martin2_amount_per, setMartin2AmountPer] = useState(2.5);
  const[martin3_reserve_gap, setMartin3ReserveGap] = useState(7.5);
  const[martin3_amount_per, setMartin3AmountPer] = useState(5.5);
  const[tp_reentry_entry_usdt_per, setTpReentryEntryUsdtPer] = useState(0.5);
  const[tp_reentry_martin1_reserve_gap, setTpReentryMartin1ReserveGap] = useState(2.0);
  const[tp_reentry_martin1_amount_per, setTpReentryMartin1AmountPer] = useState(1.0);
  const[tp_reentry_martin2_reserve_gap, setTpReentryMartin2ReserveGap] = useState(4.0);
  const[tp_reentry_martin2_amount_per, setTpReentryMartin2AmountPer] = useState(2.5);
  const[tp_reentry_martin3_reserve_gap, setTpReentryMartin3ReserveGap] = useState(7.5);
  const[tp_reentry_martin3_amount_per, setTpReentryMartin3AmountPer] = useState(5.5);
  const[re_entry_hours, setReEntryHours] = useState(2);
  const[re_entry_block_hour, setReEntryBlockHour] = useState(7);
  const[re_entry_roi_ratio, setReEntryRoiRatio] = useState(-20);
  const[after_martin_per, setAfterMartinPer] = useState(1);
  const[golden_martin, setGoldenMartin] = useState(0);
  const[day_extend, setDayExtend] = useState(0);

  const RE_ENTRY_BLOCK_HOUR_OPTIONS = [3, 4, 5, 6, 7, 8];

  const[roi_start_1,setRoiStart_1] = useState(40)
  const[roi_benefit_ratio_1,setRoiBenefitRatio_1] = useState(50)

  const[roi_start_2,setRoiStart_2] = useState(80)
  const[roi_benefit_ratio_2,setRoiBenefitRatio_2] = useState(50)

  const[roi_total_loss_ratio,setRoiTotalLossRatio] = useState(2)

  // const[benefit_ratio,setBenefitRatio] = useState(2);

  // const[benefit_reverse_count,setBenefitReverseCount] = useState(3);
  // const[benefit_reverse_ratio,setBenefitReverseRatio] = useState(1.5);

  ///////////////////////////////////////////////////////

  const[leverageValid, setLeverageValid] = useState(true);
  const[entry_usdt_per_Valid, setEntryUsdtPerValid] = useState(true);
  const[martin1_reserve_gap_Valid, setMartin1ReserveGapValid] = useState(true);
  const[martin1_amount_per_Valid, setMartin1AmountPerValid] = useState(true);
  const[martin2_reserve_gap_Valid, setMartin2ReserveGapValid] = useState(true);
  const[martin2_amount_per_Valid, setMartin2AmountPerValid] = useState(true);
  const[martin3_reserve_gap_Valid, setMartin3ReserveGapValid] = useState(true);
  const[martin3_amount_per_Valid, setMartin3AmountPerValid] = useState(true);
  const[tp_reentry_entry_usdt_per_Valid, setTpReentryEntryUsdtPerValid] = useState(true);
  const[tp_reentry_martin1_reserve_gap_Valid, setTpReentryMartin1ReserveGapValid] = useState(true);
  const[tp_reentry_martin1_amount_per_Valid, setTpReentryMartin1AmountPerValid] = useState(true);
  const[tp_reentry_martin2_reserve_gap_Valid, setTpReentryMartin2ReserveGapValid] = useState(true);
  const[tp_reentry_martin2_amount_per_Valid, setTpReentryMartin2AmountPerValid] = useState(true);
  const[tp_reentry_martin3_reserve_gap_Valid, setTpReentryMartin3ReserveGapValid] = useState(true);
  const[tp_reentry_martin3_amount_per_Valid, setTpReentryMartin3AmountPerValid] = useState(true);
  const[re_entry_hours_Valid, setReEntryHoursValid] = useState(true);
  const[re_entry_roi_ratio_Valid, setReEntryRoiRatioValid] = useState(true);
  const[after_martin_per_Valid, setAfterMartinPerValid] = useState(true);
  const[roi_start_1Valid, setRoiStart_1Valid] = useState(true);
  const[roi_benefit_ratio_1Valid, setRoiBenefitRatio_1Valid] = useState(true);
  const[roi_start_2Valid, setRoiStart_2Valid] = useState(true);
  const[roi_benefit_ratio_2Valid, setRoiBenefitRatio_2Valid] = useState(true);
  const[roi_total_loss_ratioValid, setRoiTotalLossRatioValid] = useState(true);
  // const[benefit_ratio_Valid, setBenefitRatioValid] = useState(true);
  // const[benefit_reverse_ratio_Valid, setBenefitReverseRatioValid] = useState(true);

  const[notAllow, setNotAllow] = useState(true);
  // 트래킹(apply) 중에도 강제 롱/숏 진입은 허용 — 코인만 선택되면 사용 가능
  const isEntryDisabled = symbol == 'default';

  // 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //// 유효성 검사 //

  const handleSymbol = (e) => {
    setSymbol(e.target.value);
      };
  
  const handlePositionMode = (e) => {
    setPositionMode(e.target.value);
      };

  const handleLeverage = (e) => {
    const newLeverage = e.target.value.trim();
    setLeverage(newLeverage);
      const regex = 
      /^\d*$/;
      if (regex.test(newLeverage)) {
        setLeverageValid(true);
        } 
      else {
        setLeverageValid(false);
        }
      };

  const handleEntryTime = (e) => {
    setEntryTime(e.target.value);
  };


  const handleEntryUsdtPer = (e) => {
    const newusdtper = e.target.value.trim();
    setEntryUsdtPer(newusdtper);
    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newusdtper)) {
      setEntryUsdtPerValid(true);
    } else {
      setEntryUsdtPerValid(false);
    }
  };

  const handleDecimalField = (setter, setValid) => (e) => {
    const val = e.target.value.trim();
    setter(val);
    const regex = /^-?\d*(\.\d+)?$/;
    setValid(regex.test(val));
  };

  /** 1마틴 예약간격: 0= L1 생략·L2만(첫 진입가 기준 gap2%), 0.1~100 */
  const handleMartin1GapField = (e) => {
    const val = e.target.value.trim();
    setMartin1ReserveGap(val);
    const regex = /^-?\d*(\.\d+)?$/;
    if (!regex.test(val)) {
      setMartin1ReserveGapValid(false);
      return;
    }
    const n = parseFloat(val);
    setMartin1ReserveGapValid(!Number.isNaN(n) && n >= 0 && n <= 100);
  };

  const isMartin1GapValid = (v) => {
    const n = parseFloat(v);
    return !Number.isNaN(n) && n >= 0 && n <= 100;
  };

  /** 마틴2·손절 기준 간격(%): 0.1 이상 100 이하 */
  const handleGapField = (setter, setValid) => (e) => {
    const val = e.target.value.trim();
    setter(val);
    const regex = /^-?\d*(\.\d+)?$/;
    if (!regex.test(val)) {
      setValid(false);
      return;
    }
    const n = parseFloat(val);
    setValid(!Number.isNaN(n) && n >= 0.1 && n <= 100);
  };

  const isGapValid = (v) => {
    const n = parseFloat(v);
    return !Number.isNaN(n) && n >= 0.1 && n <= 100;
  };


  const handleReEntryHours = (e) => {
    const val = e.target.value.trim();
    setReEntryHours(val);
    const regex = /^-?\d*(\.\d+)?$/;
    setReEntryHoursValid(regex.test(val));
  };

  const isReEntryRoiValid = (v) => {
    const s = String(v).trim();
    if (!/^-?\d*(\.\d+)?$/.test(s) || s === '' || s === '-' || s === '.') return false;
    const n = parseFloat(s);
    return !Number.isNaN(n);
  };

  const handleReEntryRoiRatio = (e) => {
    const val = e.target.value.trim();
    setReEntryRoiRatio(val);
    setReEntryRoiRatioValid(isReEntryRoiValid(val));
  };

  const handleRoiStart_1 = (e) => {
    const newratio = e.target.value.trim();
    setRoiStart_1(newratio);
    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newratio)) {
      setRoiStart_1Valid(true);
    } else {
      setRoiStart_1Valid(false);
    }
  };

  const handleRoiBenefitRatio_1 = (e) => {
    const newratio = e.target.value.trim();
    setRoiBenefitRatio_1(newratio);
    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newratio)) {
      setRoiBenefitRatio_1Valid(true);
    } else {
      setRoiBenefitRatio_1Valid(false);
    }
  };

  const handleRoiStart_2 = (e) => {
    const newratio = e.target.value.trim();
    setRoiStart_2(newratio);
    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newratio)) {
      setRoiStart_2Valid(true);
    } else {
      setRoiStart_2Valid(false);
    }
  };

  const handleRoiBenefitRatio_2 = (e) => {
    const newratio = e.target.value.trim();
    setRoiBenefitRatio_2(newratio);
    const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
    if (regex.test(newratio)) {
      setRoiBenefitRatio_2Valid(true);
    } else {
      setRoiBenefitRatio_2Valid(false);
    }
  };

  const handleRoiTotalLossRatio = handleGapField(setRoiTotalLossRatio, setRoiTotalLossRatioValid);
  // const handleBenefitReverseCount = (e) => {
  //   const newcount = e.target.value.trim();
  //   setBenefitReverseCount(newcount);
  // };

  // const handleBenefitReverseRatio = (e) => {
  //   const newratio = e.target.value.trim();
  //   setBenefitReverseRatio(newratio);
  //   const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
  //   if (regex.test(newratio)) {
  //     setBenefitReverseRatioValid(true);
  //   } else {
  //     setBenefitReverseRatioValid(false);
  //   }
  // };

  // const handleBenefitRatio = (e) => {
  //   const newratio = e.target.value.trim();
  //   setBenefitRatio(newratio);
  //   const regex = /^-?\d*(\.\d+)?$/; // ✅ 정수와 실수(음수 포함) 허용
  //   if (regex.test(newratio)) {
  //     setBenefitRatioValid(true);
  //   } else {
  //     setBenefitRatioValid(false);
  //   }
  // };

  /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////



  useEffect(() => {

    if(leverageValid && entry_usdt_per_Valid
      && martin1_reserve_gap_Valid && martin1_amount_per_Valid
      && martin2_reserve_gap_Valid && martin2_amount_per_Valid
      && martin3_reserve_gap_Valid && martin3_amount_per_Valid
      && tp_reentry_entry_usdt_per_Valid
      && tp_reentry_martin1_reserve_gap_Valid && tp_reentry_martin1_amount_per_Valid
      && tp_reentry_martin2_reserve_gap_Valid && tp_reentry_martin2_amount_per_Valid
      && tp_reentry_martin3_reserve_gap_Valid && tp_reentry_martin3_amount_per_Valid
      && re_entry_hours_Valid && re_entry_roi_ratio_Valid && after_martin_per_Valid
      && roi_start_1Valid && roi_benefit_ratio_1Valid && roi_start_2Valid && roi_benefit_ratio_2Valid
      && roi_total_loss_ratioValid) {
      setNotAllow(false);
      return;
    }
    setNotAllow(true);
  }, [leverageValid, entry_usdt_per_Valid,
    martin1_reserve_gap_Valid, martin1_amount_per_Valid,
    martin2_reserve_gap_Valid, martin2_amount_per_Valid,
    martin3_reserve_gap_Valid, martin3_amount_per_Valid,
    tp_reentry_entry_usdt_per_Valid,
    tp_reentry_martin1_reserve_gap_Valid, tp_reentry_martin1_amount_per_Valid,
    tp_reentry_martin2_reserve_gap_Valid, tp_reentry_martin2_amount_per_Valid,
    tp_reentry_martin3_reserve_gap_Valid, tp_reentry_martin3_amount_per_Valid,
    re_entry_hours_Valid, re_entry_roi_ratio_Valid, after_martin_per_Valid,
    roi_start_1Valid, roi_benefit_ratio_1Valid, roi_start_2Valid, roi_benefit_ratio_2Valid,
    roi_total_loss_ratioValid]);

  const onClickSearch = (symbol = 'default') => {
      let urlName
      const str = symbol;
      console.log(str);
      if(!str || str === 'default'){
        urlName = 'default'
        return;
      }else{
        const index = str.indexOf('/');
        urlName = str.substring(0,index);
      }  
    fetch(`/set_setdata_track/${urlName}`)
    .then((response) => {
      if(!response.ok) {
        throw new Error('400 아니면 500 에러남');
      }
      return response.json()
    })
    .then((result) => {
      const data = result[0]; // 안전하게 변수로 받음
      console.log('db에서 성공적으로 데이터 받아옴');
      
      setPositionMode(data.position_mode);
      setLeverage(data.leverage_info);

      setEntryTime(data.entry_time);
      setEntryUsdtPer(data.entry_usdt_per);
      setMartin1ReserveGap(data.martin1_reserve_gap ?? 2.0);
      setMartin1AmountPer(data.martin1_amount_per ?? 1.0);
      setMartin2ReserveGap(data.martin2_reserve_gap ?? 4.0);
      setMartin2AmountPer(data.martin2_amount_per ?? 2.5);
      setMartin3ReserveGap(data.martin3_reserve_gap ?? 7.5);
      setMartin3AmountPer(data.martin3_amount_per ?? 5.5);
      setTpReentryEntryUsdtPer(data.tp_reentry_entry_usdt_per ?? data.entry_usdt_per ?? 0.5);
      setTpReentryMartin1ReserveGap(data.tp_reentry_martin1_reserve_gap ?? data.martin1_reserve_gap ?? 2.0);
      setTpReentryMartin1AmountPer(data.tp_reentry_martin1_amount_per ?? data.martin1_amount_per ?? 1.0);
      setTpReentryMartin2ReserveGap(data.tp_reentry_martin2_reserve_gap ?? data.martin2_reserve_gap ?? 4.0);
      setTpReentryMartin2AmountPer(data.tp_reentry_martin2_amount_per ?? data.martin2_amount_per ?? 2.5);
      setTpReentryMartin3ReserveGap(data.tp_reentry_martin3_reserve_gap ?? data.martin3_reserve_gap ?? 7.5);
      setTpReentryMartin3AmountPer(data.tp_reentry_martin3_amount_per ?? data.martin3_amount_per ?? 5.5);
      setMartin1ReserveGapValid(isMartin1GapValid(data.martin1_reserve_gap ?? 2.0));
      setMartin2ReserveGapValid(isGapValid(data.martin2_reserve_gap ?? 4.0));
      setMartin3ReserveGapValid(isGapValid(data.martin3_reserve_gap ?? 7.5));
      setMartin3AmountPerValid(/^-?\d*(\.\d+)?$/.test(String(data.martin3_amount_per ?? 5.5).trim()));
      setTpReentryEntryUsdtPerValid(/^-?\d*(\.\d+)?$/.test(String(data.tp_reentry_entry_usdt_per ?? data.entry_usdt_per ?? 0.5).trim()));
      setTpReentryMartin1ReserveGapValid(isMartin1GapValid(data.tp_reentry_martin1_reserve_gap ?? data.martin1_reserve_gap ?? 2.0));
      setTpReentryMartin1AmountPerValid(/^-?\d*(\.\d+)?$/.test(String(data.tp_reentry_martin1_amount_per ?? data.martin1_amount_per ?? 1.0).trim()));
      setTpReentryMartin2ReserveGapValid(isGapValid(data.tp_reentry_martin2_reserve_gap ?? data.martin2_reserve_gap ?? 4.0));
      setTpReentryMartin2AmountPerValid(/^-?\d*(\.\d+)?$/.test(String(data.tp_reentry_martin2_amount_per ?? data.martin2_amount_per ?? 2.5).trim()));
      setTpReentryMartin3ReserveGapValid(isGapValid(data.tp_reentry_martin3_reserve_gap ?? data.martin3_reserve_gap ?? 7.5));
      setTpReentryMartin3AmountPerValid(/^-?\d*(\.\d+)?$/.test(String(data.tp_reentry_martin3_amount_per ?? data.martin3_amount_per ?? 5.5).trim()));
      setReEntryHours(data.re_entry_hours ?? 2);
      setReEntryHoursValid(/^-?\d*(\.\d+)?$/.test(String(data.re_entry_hours ?? 2).trim()));
      const blockHour = parseInt(data.re_entry_block_hour ?? 7, 10);
      setReEntryBlockHour(RE_ENTRY_BLOCK_HOUR_OPTIONS.includes(blockHour) ? blockHour : 7);
      setReEntryRoiRatio(data.re_entry_roi_ratio ?? -20);
      setReEntryRoiRatioValid(isReEntryRoiValid(data.re_entry_roi_ratio ?? -20));
      setAfterMartinPer(data.after_martin_per ?? 1);
      setAfterMartinPerValid(/^-?\d*(\.\d+)?$/.test(String(data.after_martin_per ?? 1).trim()));
      setGoldenMartin(parseInt(data.golden_martin, 10) === 1 ? 1 : 0);
      setRoiStart_1(data.roi_start_1);
      setRoiBenefitRatio_1(data.roi_benefit_ratio_1);
      setRoiStart_2(data.roi_start_2);
      setRoiBenefitRatio_2(data.roi_benefit_ratio_2);
      const lossGap = data.roi_total_loss_ratio;
      setRoiTotalLossRatio(lossGap);
      setRoiTotalLossRatioValid(isGapValid(lossGap ?? 2));
    })
    .catch((error) => {
      console.log('에러남');
    })
  }

  const onClickSymbol_save = () => {

    if (symbol === "default") {
      alert('코인을 먼저 선택하세요!');
      return; // Stop execution if the condition is met
    }
    
    let confirmed = false

    confirmed = window.confirm(symbol + '의 셋팅값을 변경하시겠습니까?');

    if (confirmed) {
      console.log('셋팅 스타트 버튼 클릭')
      fetch('/set_start_track', {
        method : 'POST',
        headers: {
          'Content-Type' : 'application/json',
        },
        body: JSON.stringify({
          uid,
          symbol,
          position_mode,
          leverage_info,
          entry_time,
          entry_usdt_per,
          martin1_reserve_gap,
          martin1_amount_per,
          martin2_reserve_gap,
          martin2_amount_per,
          martin3_reserve_gap,
          martin3_amount_per,
          tp_reentry_entry_usdt_per,
          tp_reentry_martin1_reserve_gap,
          tp_reentry_martin1_amount_per,
          tp_reentry_martin2_reserve_gap,
          tp_reentry_martin2_amount_per,
          tp_reentry_martin3_reserve_gap,
          tp_reentry_martin3_amount_per,

          re_entry_hours,
          re_entry_block_hour,
          re_entry_roi_ratio,
          after_martin_per,
          golden_martin: 0, // 금마 비활성화
          day_extend,
          roi_start_1,
          roi_benefit_ratio_1,
          roi_start_2,
          roi_benefit_ratio_2,
          roi_total_loss_ratio
          }),
        })
        .then(response => response.json())  // 응답을 JSON 형식으로 변환
        .then(data => {
        onClickSearch(symbol);
        alert(data.message);  // JSON에서 message 값을 가져옴
        })
        .catch(error => console.error('Error:', error));
      };
  };

  const onClickTotal_save = () => {

    let confirmed = false

    confirmed = window.confirm('전체코인 셋팅값을 변경하시겠습니까?');

    if (confirmed) {
      console.log('전체셋팅 버튼 클릭')
      fetch('/set_total_track', {
        method : 'POST',
        headers: {
          'Content-Type' : 'application/json',
        },
        body: JSON.stringify({
          uid,
          symbol,
          position_mode,
          leverage_info,
          entry_time,
          entry_usdt_per,
          martin1_reserve_gap,
          martin1_amount_per,
          martin2_reserve_gap,
          martin2_amount_per,
          martin3_reserve_gap,
          martin3_amount_per,
          tp_reentry_entry_usdt_per,
          tp_reentry_martin1_reserve_gap,
          tp_reentry_martin1_amount_per,
          tp_reentry_martin2_reserve_gap,
          tp_reentry_martin2_amount_per,
          tp_reentry_martin3_reserve_gap,
          tp_reentry_martin3_amount_per,

          re_entry_hours,
          re_entry_block_hour,
          re_entry_roi_ratio,
          after_martin_per,
          golden_martin: 0, // 금마 비활성화
          day_extend,
          roi_start_1,
          roi_benefit_ratio_1,
          roi_start_2,
          roi_benefit_ratio_2,
          roi_total_loss_ratio
          }),
        })
        .then(response => response.json())  // 응답을 JSON 형식으로 변환
        .then(data => {
        onClickSearch(symbol);
        alert(data.message);  // JSON에서 message 값을 가져옴
        })
        .catch(error => console.error('Error:', error));
      };
  };

  const onClickLongEntry = () => {
    if (symbol === "default") {
      alert('코인을 먼저 선택하세요!');
      return; // Stop execution if the condition is met
    }
    let confirmed = false
    confirmed = window.confirm(`${symbol}의 일괄 롱 진입을 하시겠습니까?`);
    if (confirmed) {
      console.log('일괄 롱 진입 버튼 클릭')
      fetch('/set_long_entry', {
        method : 'POST',
        headers: {
          'Content-Type' : 'application/json',
        },
        body: JSON.stringify({
          symbol
        }),
      })
      .then(response => response.json())  // 응답을 JSON 형식으로 변환
      .then(data => {
        alert(data.message);  // JSON에서 message 값을 가져옴
      })
      .catch(error => console.error('Error:', error));
    };
  };

  const onClickShortEntry = () => {
    if (symbol === "default") {
      alert('코인을 먼저 선택하세요!');
      return; // Stop execution if the condition is met
    }
    let confirmed = false
    confirmed = window.confirm(`${symbol}의 일괄 숏 진입을 하시겠습니까?`);
    if (confirmed) {
      console.log('일괄 숏 진입 버튼 클릭')
      fetch('/set_short_entry', {
        method : 'POST',
        headers: {
          'Content-Type' : 'application/json',
        },
        body: JSON.stringify({
          symbol
        }),
      })
      .then(response => response.json())  // 응답을 JSON 형식으로 변환
      .then(data => {
        alert(data.message);  // JSON에서 message 값을 가져옴
      })
      .catch(error => console.error('Error:', error));
    };
  };

  const onClickForceClose = () => {
    if (symbol === "default") {
      alert('코인을 먼저 선택하세요!');
      return; // Stop execution if the condition is met
    }
    let confirmed = false
    confirmed = window.confirm(`${symbol}의 강제 정리를 하시겠습니까?`);
    if (confirmed) {
      console.log('강제 정리 버튼 클릭')
      fetch('/set_force_close', {
        method : 'POST',
        headers: {
          'Content-Type' : 'application/json',
        },
        body: JSON.stringify({
          symbol
        }),
      })
      .then(response => response.json())  // 응답을 JSON 형식으로 변환
      .then(data => {
        alert(data.message);  // JSON에서 message 값을 가져옴
      })
      .catch(error => console.error('Error:', error));
    };
  };

  //로그아웃
  const onClickEnd = () => {
    const uuid = cookies.uuid; // cookies에서 uuid를 얻어옴
    if (!uuid) {
      alert('로그인 정보가 존재하지 않습니다.');
      return;
    }
    // 로그아웃 요청을 서버로 보냅니다.
    fetch('/logout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userId: uuid })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('로그아웃 요청 실패');
      }
      console.log('로그아웃 성공');
      alert('Logout is successful.');
      window.location.href = '/';
    })
    .catch(error => {
      console.error('로그아웃 요청 중 오류 발생:', error);
    });
    // UUID를 서버로 보내는 예시 코드
  }

  const handleMoveTrack = () => {
    navigate("/SetPage");
  };

  return (
      <div style={styles.page}>
        <div style={styles.container}>
          <div style={styles.card}>
            <div style={styles.headerRow}>
              <div style={styles.titleWrap}>
                <span style={styles.badge}>Speed BOT</span>
                <h1 style={styles.title}>Setting Page TRACK version</h1>
                <p style={styles.helper}>심볼별 포지션 모드, 레버리지, 롱/숏 진입비율 등을 설정하세요.</p>
                {/* <button type="button" style={styles.trackButton} onClick={handleMoveTrack}>
                  WEB version set 으로 이동
                </button> */}
              </div>
            </div>
            <div className="container">
            <div className="column_leverage">
            <div class="button_benefit_leverage">
            <div className="leverage_item">SYMBOL</div>
              <select className="usdt_select_lv_samaria" 
                value = {symbol}
                onChange={(e) => {setSymbol(e.target.value);
                                  onClickSearch(e.target.value);}}>
                <option value="default">선택</option>
                <option value="ETH/USDT:USDT">이더리움</option>
                <option value="XRP/USDT:USDT">리플</option>
                <option value="SOL/USDT:USDT">솔라나</option>
                <option value="DOGE/USDT:USDT">도지</option>
                <option value="BTC/USDT:USDT">비트코인</option>
              </select>
            </div>
            <div className="line"></div>
            <div className="line"></div>
            <div class="leverage_container">
              <div class="leverage_item">모드선택</div>
                <select className="select_samaria" 
                  value={position_mode}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={(e) => {
                    setPositionMode(e.target.value);
                  }}>
                  <option value="CROSS">교차</option>
                  <option value="ISOLATED">격리</option>
                </select>
              </div>
              {/* [금마 비활성화]
              <div class="leverage_container">
                <div class="leverage_item">금마</div>
                <select
                  className="select_samaria"
                  value={golden_martin}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={(e) => setGoldenMartin(parseInt(e.target.value, 10) === 1 ? 1 : 0)}>
                  <option value={0}>미적용</option>
                  <option value={1}>적용</option>
                </select>
              </div>
              */}
              <div class="leverage_container">
                <div class="leverage_item">1일연장 (전체)</div>
                <select
                  className="select_samaria"
                  value={day_extend}
                  onChange={(e) => setDayExtend(parseInt(e.target.value, 10) === 1 ? 1 : 0)}>
                  <option value={0}>미적용</option>
                  <option value={1}>적용</option>
                </select>
              </div>
              <div class="leverage_container">
                <div class="leverage_item">Leverage set</div>
                  <input 
                  type="number"
                  step="1"
                  class="leverage_input_basic"
                  value={leverage_info}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleLeverage} />
            </div>
            <div className="line"></div>
            <div class="center_text_lever">ENTRY setting</div>
            <div class="leverage_container">
              <div class="leverage_item">진입시간기준</div>
                <select
                  class="leverage_input_basic"
                  value={entry_time}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleEntryTime}>
                  <option value="9:00">9:00</option>
                  <option value="9:30">9:30</option>
                </select>
            </div>
            <div class="leverage_container">
              <div class="leverage_item">진입 USDT(%)</div>
                <input 
                  type="number"
                  step="1"
                  class="leverage_input_basic"
                  value={entry_usdt_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleEntryUsdtPer}>
                </input>
            </div>
            <div class="leverage_container">
              <div class="leverage_item">1마틴예약간격(%)</div>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  max="100"
                  class="leverage_input_basic"
                  value={martin1_reserve_gap}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleMartin1GapField} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">1마틴금액(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={martin1_amount_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleDecimalField(setMartin1AmountPer, setMartin1AmountPerValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">2마틴예약간격(%)</div>
                <input
                  type="number"
                  step="0.1"
                  min="0.1"
                  max="100"
                  class="leverage_input_basic"
                  value={martin2_reserve_gap}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleGapField(setMartin2ReserveGap, setMartin2ReserveGapValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">2마틴금액(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={martin2_amount_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleDecimalField(setMartin2AmountPer, setMartin2AmountPerValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">3마틴예약간격(%)</div>
                <input
                  type="number"
                  step="0.1"
                  min="0.1"
                  max="100"
                  class="leverage_input_basic"
                  value={martin3_reserve_gap}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleGapField(setMartin3ReserveGap, setMartin3ReserveGapValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">3마틴금액(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={martin3_amount_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleDecimalField(setMartin3AmountPer, setMartin3AmountPerValid)} />
            </div>
            <div className="line"></div>
            <div class="center_text_lever">익절 후 진입기준</div>
            <div class="leverage_container">
              <div class="leverage_item">진입 USDT(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={tp_reentry_entry_usdt_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleDecimalField(setTpReentryEntryUsdtPer, setTpReentryEntryUsdtPerValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">1마틴예약간격(%)</div>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  max="100"
                  class="leverage_input_basic"
                  value={tp_reentry_martin1_reserve_gap}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={(e) => {
                    const val = e.target.value.trim();
                    setTpReentryMartin1ReserveGap(val);
                    setTpReentryMartin1ReserveGapValid(isMartin1GapValid(val));
                  }} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">1마틴금액(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={tp_reentry_martin1_amount_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleDecimalField(setTpReentryMartin1AmountPer, setTpReentryMartin1AmountPerValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">2마틴예약간격(%)</div>
                <input
                  type="number"
                  step="0.1"
                  min="0.1"
                  max="100"
                  class="leverage_input_basic"
                  value={tp_reentry_martin2_reserve_gap}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleGapField(setTpReentryMartin2ReserveGap, setTpReentryMartin2ReserveGapValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">2마틴금액(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={tp_reentry_martin2_amount_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleDecimalField(setTpReentryMartin2AmountPer, setTpReentryMartin2AmountPerValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">3마틴예약간격(%)</div>
                <input
                  type="number"
                  step="0.1"
                  min="0.1"
                  max="100"
                  class="leverage_input_basic"
                  value={tp_reentry_martin3_reserve_gap}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleGapField(setTpReentryMartin3ReserveGap, setTpReentryMartin3ReserveGapValid)} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">3마틴금액(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={tp_reentry_martin3_amount_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleDecimalField(setTpReentryMartin3AmountPer, setTpReentryMartin3AmountPerValid)} />
            </div>
            <div className="line"></div>
            <div class="center_text_lever">RE ENTRY setting</div>
            <div class="leverage_container">
              <div class="leverage_item">재진입시간설정(시간)</div>
                <input
                  type="number"
                  step="0.5"
                  min="0"
                  class="leverage_input_basic"
                  value={re_entry_hours}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleReEntryHours} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">재진입방지시간</div>
                <select
                  class="leverage_input_basic"
                  value={re_entry_block_hour}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={(e) => setReEntryBlockHour(parseInt(e.target.value, 10))}>
                  {RE_ENTRY_BLOCK_HOUR_OPTIONS.map((h) => (
                    <option key={h} value={h}>{h}:00</option>
                  ))}
                </select>
            </div>
            <div class="leverage_container">
              <div class="leverage_item">재진입ROI기준(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={re_entry_roi_ratio}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleReEntryRoiRatio} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item">마틴이후ROI기준(%)</div>
                <input
                  type="number"
                  step="0.1"
                  class="leverage_input_basic"
                  value={after_martin_per}
                  disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleDecimalField(setAfterMartinPer, setAfterMartinPerValid)} />
            </div>
            <div className="line"></div>
            <div className="line"></div>
            <div class="center_text_lever">BENEFIT setting</div>
            <div class="leverage_container">
              <div class="leverage_item"
              style={{
                filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
              }}>ROI 시작(%)</div>
                <input 
                  type="number"
                  step="1"
                  class="leverage_input_basic"
                  value={roi_start_1}
                  disabled={symbol == 'default' || symbol == 'BTC/USDT:USDT'}
                  style={{
                    filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleRoiStart_1} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item"
              style={{
                filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
              }}>ROI 이익보전률(%)</div>
                <input 
                  type="number"
                  step="1"
                  class="leverage_input_basic"
                  value={roi_benefit_ratio_1}
                  disabled={symbol == 'default' || symbol == 'BTC/USDT:USDT'}
                style={{
                  filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
                }}
                onChange={handleRoiBenefitRatio_1} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item"
              style={{
                filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
              }}>ROI 최대이익시작(%)</div>
                <input 
                type="number"
                step="1"
                class="leverage_input_basic"
                value={roi_start_2}
                disabled={symbol == 'default' || symbol == 'BTC/USDT:USDT'}
                  style={{
                    filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
                  }}
                onChange={handleRoiStart_2} />
            </div>
            <div class="leverage_container">
              <div class="leverage_item"
              style={{
                filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
              }}>ROI 최대이익보전률(%)</div>
                <input 
                  type="number"
                  step="1"
                  class="leverage_input_basic"
                  value={roi_benefit_ratio_2}
                  disabled={symbol == 'default' || symbol == 'BTC/USDT:USDT'}
                  style={{
                    filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleRoiBenefitRatio_2} />
            </div>
            <div className="line"></div>
            <div class="center_text_lever">TOTAL LOSS setting</div>
            <div class="leverage_container">
              <div class="leverage_item">3마틴 기준 추가 하락(%)</div>
                <input 
                  type="number"
                  step="0.1"
                  min="0.1"
                  max="100"
                  class="leverage_input_basic"
                  value={roi_total_loss_ratio}
                  disabled={symbol == 'default' || symbol == 'BTC/USDT:USDT'}
                  style={{
                    filter: (symbol == 'default' || symbol == 'BTC/USDT:USDT') ? 'blur(4px)' : 'none',
                  }}
                  onChange={handleRoiTotalLossRatio} />
            </div>
            <div className="line"></div>
          <div className="button_benefit_leverage">
              <button onClick={() => onClickLongEntry()} disabled={isEntryDisabled}
                   className="button_benefit_c_lever">
              롱 진입
              </button>
              <button onClick={() => onClickShortEntry()} disabled={isEntryDisabled}
                  className="button_benefit_c_lever">
              숏 진입
              </button>
              </div>
              <div className="button_benefit_leverage">
              <button onClick={() => onClickForceClose()} disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }} className="bottomButton_sp_lever">
              강제정리
              </button>
           </div>

          <div className="line"></div>

          <div className="button_benefit_leverage">
              <button onClick={() => onClickSymbol_save()} disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }} className="button_benefit_c_lever">
              선택 코인 저장
              </button>
              <button onClick={() => onClickTotal_save()} disabled={symbol == 'default'}
                  style={{
                    filter: (symbol == 'default') ? 'blur(4px)' : 'none',
                  }} className="button_benefit_c_lever">
              전체 코인 저장
              </button>
          </div>  
          <div className="button_benefit_leverage">
              <button onClick={() => onClickEnd()} disabled={notAllow} className="bottomButton_sp_lever">
              로그아웃
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}